import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './App.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

// Inglés
import Us from '../Pages/en/Us/Us';
import SuccessStories from '../Pages/en/Success-stories/Success-stories';
import Azfa from '../Pages/en/azfa/azfa';
import EcoRolling from '../Pages/en/EcoRolling/Ecorolling';
import Contact from '../Pages/en/Contact/Contact';
import Products from "../Pages/en/Products";
import Tourism from "../Pages/en/Products/tourism";
import Digital from "../Pages/en/Products/digital";
import Education from "../Pages/en/Products/education";

// Español
import UsE from '../Pages/es/Us/Us';
import SuccessStoriesE from '../Pages/es/Success-stories/Success-stories';
import AzfaE from '../Pages/es/azfa/azfa'; // Se cambia el nombre del import a AzfaE para evitar el error de duplicado
import EcoRollingE from '../Pages/es/EcoRolling/Ecorolling';
import ContactE from '../Pages/es/Contact/Contact';
import ProductsE from "../Pages/es/Products";
import TourismE from "../Pages/es/Products/tourism";
import DigitalE from "../Pages/es/Products/digital";
import EducationE from "../Pages/es/Products/education";

function LanguageRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      const browserLang = (navigator.language || 'en').split('-')[0];
      const targetLang = browserLang === 'es' ? 'es' : 'en';
      navigate(`/${targetLang}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
}

function App() {
  return (
    <div>
      <Helmet>
        <title>Backend Helpers Limited</title>
      </Helmet>

      <BrowserRouter>
        <LanguageRedirect />
        
        <Header />

        <Routes>
          {/* Inglés */}
          <Route path="/en" element={<Us />} />
          <Route path="/en/products" element={<Products />} />
          <Route path="/en/products/eco-rolling-ai" element={<Tourism />} />
          <Route path="/en/products/step-forward-digital" element={<Digital />} />
          <Route path="/en/products/academy" element={<Education />} />
          <Route path="/en/success-stories" element={<SuccessStories />} />
          <Route path="/en/success-stories/aws-azfa" element={<Azfa />} />
          <Route path="/en/success-stories/ecorolling" element={<EcoRolling />} />
          <Route path="/en/contact" element={<Contact />} />

          {/* Español */}
          <Route path="/es" element={<UsE />} />
          <Route path="/es/products" element={<ProductsE />} />
          <Route path="/es/products/eco-rolling-ai" element={<TourismE />} />
          <Route path="/es/products/step-forward-digital" element={<DigitalE />} />
          <Route path="/es/products/academy" element={<EducationE />} />
          <Route path="/es/historias-exito" element={<SuccessStoriesE />} />
          <Route path="/es/historias-exito/aws-azfa" element={<AzfaE />} />
          <Route path="/es/historias-exito/ecorolling" element={<EcoRollingE />} />
          <Route path="/es/contacto" element={<ContactE />} />
         
          <Route path="*" element={<Navigate to="/es" />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;